<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 施設情報詳細（追加・編集）の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
    <!-- ホーム -->
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>施設情報：編集（ホーム）の説明</span></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/facility-dialog-home-ja.png"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> 更新ボタン</div>
            <div class="manual-explain">
              クリックすることで編集内容が更新されます。
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> 閉じるボタン</div>
            <div class="manual-explain">
              クリックすることでダイアログを閉じます。<br>
              その際、編集した内容は保存されません。
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> ID</div>
            <div class="manual-explain">
              IDを設定します。<br>
              *既に登録済みのIDは利用することができません。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> 施設属性</div>
            <div class="manual-explain">
              施設属性を設定します。<br>
              *<a [href]="facilityAttributeDialogLink">施設属性画面</a>で登録された情報から選択します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> 名称</div>
            <div class="manual-explain">
              名称を設定します。<br>
              編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/F.png"> 詳細</div>
            <div class="manual-explain">
              詳細を設定します。<br>
              編集ボタンから<a [href]="descDialogLink">編集用ダイアログ</a>を開き設定します。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/G.png"> 施設画像ファイル</div>
            <div class="manual-explain">
              ホーム画面に画像を表示する場合に設定します。複数の設定が可能です。<br>
              複数設定した場合は一定間隔で画像が入れ替わるような表示になります。<br>
              ファイル追加ボタンからファイルを選択します。<br>
              ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
              ※言語ごとの画像設定が可能です。該当言語の画像がない場合は英語用、英語用の画像が登録されない場合は日本語用の画像が表示されます。<br>
              メイン画像は複数登録可能です。複数登録した場合、画像はスライド表示されます。<br>
              また、施設画像はドラッグ&ドロップで並び替えが可能です。<br>
              ※画像の推奨サイズ（縦横比）は以下になります。<br>
              &nbsp;&nbsp;メイン画像：1 : 1（例）高さ1400px、幅1400px
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/H.png"> 画像の上に概要（名称や詳細）を重ねない</div>
            <div class="manual-explain">
              ホーム画面では、画像表示領域の下に概要（名称や詳細）表示領域が配置され、デフォルトでは画像の上に概要の一部が重なるような表示になります。<br>
              チェックを入れると画像の上に概要が重ならないような表示になります。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/I.png"> 画像タップでメニューを表示する（※登録画像が1つの時に有効）</div>
            <div class="manual-explain">
              チェックを入れると、施設画像ファイルの登録が1つの時に、ホーム画面上で画像をタップするとメニューを表示させます。<br>
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/J.png"> YouTubeを使用する</div>
            <div class="manual-explain">
              チェックを入れると、ホーム画面の画像表示領域にYoutube動画を表示します。<br>
              YouTubeの埋め込みコードには表示したいYoutubeのURL（https://www.youtube.com/watch?...）を設定します。<br>
              *共有リンクで使われる短縮形式のアドレス（https://youtu.be...）では上手く表示されない可能性があるので注意してください。<br>
              編集ボタンから<a [href]="youtubeDialogLink">編集用ダイアログ</a>を開き設定します。<br>
              <span class="manual-explain-notes">*チェックを入れた場合、必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/K.png"> 外部リンクを使用する</div>
            <div class="manual-explain">
              チェックを入れると、ホーム画面に外部リンクを表示します。<br>
              外部リンク名と、リンク先のURLを設定します。<br>
              編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ（名称）</a>、<a [href]="urlDialogLink">編集用ダイアログ（URL）</a>を開き設定します。<br>
              <span class="manual-explain-notes">*チェックを入れた場合、必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/L.png"> マップ情報</div>
            <div class="manual-explain">
              施設の位置情報を設定します。<br>
              マップ内の検索キーワード、または緯度軽度から指定可能です。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/M.png"> 地図ズーム初期値（ホーム画面）</div>
            <div class="manual-explain">
              ホーム画面に表示される地図のズーム初期値を設定します。<br>
              ※数値が大きいほどズームアップします
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/N.png"> 地図ズーム初期値（MAP画面）</div>
            <div class="manual-explain">
              MAP画面に表示される地図のズーム初期値を設定します。<br>
              ※数値が大きいほどズームアップします
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/O.png"> GoogleMAP表示タイプ</div>
            <div class="manual-explain">
              フロアページ、展示物ページなどのGoogleMapの表示形式を選択することができます。<br>
              地図タイプ／航空写真タイプから選択します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/P.png"> 電話番号</div>
            <div class="manual-explain">
              電話番号を設定します。<br>
              「000-1234-5678」の形式で入力してください。
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/Q.png"> 住所</div>
            <div class="manual-explain">
              住所を設定します。<br>
              編集ボタンから<a [href]="addressDialogLink">編集用ダイアログ</a>を開き設定します。<br>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- ヘッダー／フッター -->
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>施設情報：編集（ヘッダー／フッター）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/facility-dialog-header-ja.png" width="100%"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> faviconファイル</div>
            <div class="manual-explain">
              faviconを設定します。<br>
              ファイル追加ボタンからファイルを選択します。<br>
              ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> ロゴ画像ファイル</div>
            <div class="manual-explain">
              施設のロゴ画像を設定します。<br>
              ファイル追加ボタンからファイルを選択します。<br>
              ※ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
              ※言語ごとの画像設定が可能です。該当言語の画像がない場合は英語用、英語用の画像が登録されない場合は日本語用の画像が表示されます。<br>
              ※画像の推奨サイズ（縦横比）は以下になります。<br>
              &nbsp;&nbsp;ロゴ画像：1 : 4.5（例）高さ約150px、幅700px
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> FAQ</div>
            <div class="manual-explain">
              FAQを設定します。<br>
              編集ボタンから<a [href]="faqDialogLink">編集用ダイアログ</a>を開き設定します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> プライバシーポリシー</div>
            <div class="manual-explain">
              プライバシーポリシーを設定します。<br>
              編集ボタンから<a [href]="policyDialogLink">編集用ダイアログ</a>を開き設定します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> コピーライト</div>
            <div class="manual-explain">
              コピーライトを設定します。<br>
              編集ボタンから<a [href]="copyrightDialogLink">編集用ダイアログ</a>を開き設定します。<br>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- アプリ表示 -->
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>施設情報：編集（アプリ表示）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/facility-dialog-disp.png" width="100%"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> テーマカラー</div>
            <div class="manual-explain">
              ユーザーアプリのテーマカラーを設定します。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> メニューアイコンに「メニュー」を表示しない</div>
            <div class="manual-explain">
              チェックを入れると、メニューアイコン（ボタン）のイメージが「アイコン＋メニュー」から「アイコン」のみに変わります。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> 「言語」の使用について</div>
            <div class="manual-explain">
              「言語」の使用方法について設定します。<br>
              「地球儀」･･･ ユーザーアプリの言語切り替えボタンのアイコン部分を「地球儀」に変更します。<br>
              「Lang」･･･ ユーザーアプリの言語切り替えボタンのアイコン部分を「Lang」に変更します。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>            
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> 「ガイド」の使用について</div>
            <div class="manual-explain">
              「ガイド」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「ガイド」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「ガイド」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「ガイド」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「ガイド」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> 「番号入力」の使用について</div>
            <div class="manual-explain">
              「番号入力」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「番号入力」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「番号入力」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「番号入力」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「番号入力」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/F.png"> メニューの「番号入力」を別名に変更する</div>
            <div class="manual-explain">
              チェックを入れると、「番号入力」を別名に変更することができます。<br>
              編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ（名称）</a>を開き設定します。<br>
              <span class="manual-explain-notes">*メニューの「番号入力」を別名に変更するにチェックを入れた場合、必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/G.png"> 説明文</div>
            <div class="manual-explain">
              「番号入力」ページに表示する「説明を見たい展示物の番号を入力してください。」を変更する場合に設定します。<br>
              編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ（名称）</a>を開き設定します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/H.png"> 「アンケート」の使用について</div>
            <div class="manual-explain">
              「アンケート」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「アンケート」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「アンケート」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「アンケート」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「アンケート」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/I.png"> アンケート終了時にありがとうページを表示する</div>
            <div class="manual-explain">
              チェックを入れると、アンケート回答後にありがとうページを表示することができます。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/J.png"> 「アンケートへのご回答ありがとうございました」を変更する</div>
            <div class="manual-explain">
              チェックを入れると、ありがとうページに表示する「アンケートへのご回答ありがとうございました」を変更することができます。<br>
              編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ（名称）</a>を開き設定します。<br>
              <span class="manual-explain-notes">*「アンケートへのご回答ありがとうございました」を変更するにチェックを入れた場合、必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/K.png"> 「ランキング」の使用について</div>
            <div class="manual-explain">
              「ランキング」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「ランキング」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「ランキング」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「ランキング」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「ランキング」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/L.png"> 「避難所」の使用について</div>
            <div class="manual-explain">
              「避難所」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「避難所」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「避難所」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「避難所」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「避難所」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/M.png"> 「購入」の使用について</div>
            <div class="manual-explain">
              「購入」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「購入」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「購入」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「購入」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「購入」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/N.png"> メニューの「購入」を別名に変更する</div>
            <div class="manual-explain">
              「購入」を別名に変更する場合に設定します。<br>
              編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ（名称）</a>を開き設定します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/O.png"> 「全体マップ」の使用について</div>
            <div class="manual-explain">
              「全体マップ」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「全体マップ」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「全体マップ」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「全体マップ」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「全体マップ」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/P.png"> 「現在位置を見る」をタップした時の動作</div>
            <div class="manual-explain">
              「全体マップ」で「現在位置を見る」をタップした時の動作について設定します。<br>
              「音声自動再生OFF」･･･ コンテンツ情報の自動表示と音声再生をしません。<br>
              「音声自動再生ON（現在地から10m範囲内）」･･･ 現在地から10m範囲内にコンテンツがある場合、最寄りのコンテンツ情報の自動表示／音声再生を行います。<br>
              「音声自動再生ON（現在地から20m範囲内）」･･･ 現在地から20m範囲内にコンテンツがある場合、最寄りのコンテンツ情報の自動表示／音声再生を行います。<br>
              「音声自動再生ON（現在地から50m範囲内）」･･･ 現在地から50m範囲内にコンテンツがある場合、最寄りのコンテンツ情報の自動表示／音声再生を行います。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/Q.png"> 「エントリーフォーム」の使用について</div>
            <div class="manual-explain">
              「エントリーフォーム」の使用方法について設定します。<br>
              「使わない」･･･ ユーザーアプリのメニュー「エントリーフォーム」を非表示にして、使用できないようにします。<br>
              「PCとスマホで使う」･･･ ユーザーアプリのメニュー「エントリーフォーム」を表示して、使用できるようにします。<br>
              「PCで使う」･･･ ユーザーアプリ（PCサイズ版）のみメニュー「エントリーフォーム」を表示して、使用できるようにします。<br>
              「スマホで使う」･･･ ユーザーアプリ（スマホサイズ版）のみメニュー「エントリーフォーム」を表示して、使用できるようにします。<br>
              <span class="manual-explain-notes">*必須項目</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/R.png"> フロア・表示グループリスト</div>
            <div class="manual-explain">
              フロア・表示グループを設定します。<br>
              フロア・表示グループリスト追加ボタンからフロア・表示グループを選択します。<br>
              ※フロア・表示グループは、<a [href]="floorDialogLink">フロア・表示グループ情報画面</a>で事前に登録してある必要があります。<br>
              フロア・表示グループリストはドラッグ&ドロップで並び替えが可能です。
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/S.png"> 階層ナビゲーション（パンくずリスト）を表示しない</div>
            <div class="manual-explain">
              チェックを入れると、ガイドページ内、フロア・表示グループページ内の上部の階層ナビゲーション（パンくずリスト）を表示しません。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/T.png"> 展示物ページに「いいね」ボタンを表示する</div>
            <div class="manual-explain">
              チェックを入れると、展示物ページ内の概要に「いいね」ボタンを表示します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/U.png"> 展示物ページの「ガイド」「番号入力」ボタンを表示しない</div>
            <div class="manual-explain">
              チェックを入れると、展示物ページ内の「ガイド」「番号入力」ボタンを表示しません。<br>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

  </div>

  <!-- アプリ運用 -->
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>施設情報：編集（アプリ運用）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/facility-dialog-ope-ja.png" width="100%"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> メタキーワード</div>
            <div class="manual-explain">
              メタキーワードを設定します。<br>
              ヘッダのメタタグ: keywords に反映されます。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> メタディスクリプション</div>
            <div class="manual-explain">
              メタディスクリプションを設定します。<br>
              ヘッダのメタタグ: description に反映されます。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> Google Analytics トラッキングコード</div>
            <div class="manual-explain">
              Google Analytics トラッキングコードを設定します。<br>
              ※ご利用の際は、Google Analyticsに登録後タグ情報をお知らせ下さい。サイトに設置させていただきます。
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> サイトURL(QRコード生成用)</div>
            <div class="manual-explain">
              QRコード生成用のサイトURLを設定します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> ステージングサイトURL</div>
            <div class="manual-explain">
              ステージングサイトURLを設定します。<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/F.png"> SPLATSキーボックスリスト</div>
            <div class="manual-explain">
              SPLATSキーボックスを設定します。<br>
              環境(共用環境・本番環境)を選択すると、その環境で所有するキーボックスの一覧を名称に表示します。<br>
              ※SPLATSキーボックスは、<a [href]="splatsLink">SPLATS情報画面</a>で事前に共用環境や本番環境のアクセストークンが登録してある必要があります。<br>
              SPLATSキーボックスリストはドラッグ&ドロップで並び替えが可能です。
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>





<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Facility Details (Add/Edit)
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
    <!-- ホーム -->
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Details(Home)</span></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/en_facility-dialog-home.png"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> Update Button</div>
            <div class="manual-explain">
              Clicking this button will apply the edited content.
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> Close Button</div>
            <div class="manual-explain">
              Clicking this button will close the dialog.<br>
              Edited content will not be saved.
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> ID</div>
            <div class="manual-explain">
              Set the ID.<br>
              *You cannot use an ID that has already been registered.<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> Attribute</div>
            <div class="manual-explain">
              Set facility attributes.<br>
              *Select from the information registered on the <a [href]="facilityAttributeDialogLink">Facility Attributes Information</a><br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> Name</div>
            <div class="manual-explain">
              Set the name.<br>
              Open the <a [href]="nameDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/F.png"> Detail</div>
            <div class="manual-explain">
              Set the details.<br>
              Open the <a [href]="descDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/G.png"> Facility Image File</div>
            <div class="manual-explain">
              Set this to display an image on the home screen. Multiple settings are possible.<br>
              If multiple images are set, the images will be displayed alternately at regular intervals.<br>
              Select the file using the "Add File" button.<br>
              *The file must be uploaded in advance on the <a [href]="uploaderLink">Upload File Screen</a><br>
              *You can set an image for each language. If there is no image for the language, the English image will be displayed, and if no English image is registered, the Japanese image will be displayed.<br>
              You can register multiple main images. If multiple images are registered, they will be displayed as slides.<br>
              Facility images can also be rearranged using drag and drop.<br>
              *The recommended image size (aspect ratio) is as follows:<br>
              &nbsp;&nbsp;Main image: 1:1 (example) height 1400px, width 1400px
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/H.png"> Do Not Overlay Overview (Name and Detail) on Image</div>
            <div class="manual-explain">
              On the home screen, the overview (name and details) display area is located below the image display area, and by default, part of the overview overlaps on top of the image.<br>
              If you check this box, the summary will not overlap the image.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/I.png"> Tap the image to display the menu (only available when there is one registered image)</div>
            <div class="manual-explain">
              If you check this box, and there is only one facility image file registered, a menu will be displayed when you tap the image on the home screen.<br>
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/J.png"> Use YouTube</div>
            <div class="manual-explain">
              Check this box to display YouTube videos in the image display area of the home screen.<br>
              In the YouTube embed code, set the YouTube URL you want to display (https://www.youtube.com/watch?...).<br>
              *Please note that the shortened address used in shared links (https://youtu.be...) may not display properly.<br>
              Click the edit button to open the <a [href]="youtubeDialogLink">edit dialog</a> and set it up.<br>
              <span class="manual-explain-notes">*If checked, this is a required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/K.png"> Use External Link</div>
            <div class="manual-explain">
              Check this box to display external links on the home screen.<br>
              Set the external link name and the URL of the link destination.<br>
              Click the edit button to open the <a [href]="nameDialogLink">name dialog</a>, the <a [href]="urlDialogLink">External Link URL dialog</a> and set it up.<br>
              <span class="manual-explain-notes">*If checked, this is a required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/L.png"> Map Information</div>
            <div class="manual-explain">
              Set the location information of the facility.<br>
              You can search by keyword on the map or by latitude and longitude.<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/M.png"> Map Zoom Initial Value(Home Screen)</div>
            <div class="manual-explain">
              Set the initial zoom value for the map displayed on the home screen.<br>
              *The larger the number, the more zoomed in.
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/N.png"> Map Zoom Initial Value(Map Screen)</div>
            <div class="manual-explain">
              Set the initial zoom value for the map displayed on the MAP screen.<br>
              *The larger the number, the more zoomed in.
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/O.png"> Google MAP Display Type</div>
            <div class="manual-explain">
              You can select the Google Maps display format for floor pages, exhibit pages, etc.<br>
              Select from map type or aerial photo type.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/P.png"> Phone Number</div>
            <div class="manual-explain">
              Set your phone number.<br>
              Please enter in the format "000-1234-5678".
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/Q.png"> Address</div>
            <div class="manual-explain">
              Set address.<br>
              Open the <a [href]="addressDialogLink">Address Dialog</a> from the edit button to configure it.<br>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- ヘッダー／フッター -->
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Details(Header/Footer)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/en_facility-dialog-header.png" width="100%"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> Favicon File</div>
            <div class="manual-explain">
              Set a favicon.<br>
              Select the file using the "Select File" button.<br>
              *The file must be uploaded in advance on the <a [href]="uploaderLink">Upload File Screen</a><br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> Logo Image File</div>
            <div class="manual-explain">
              Set the facility logo image.<br>
              Select the file using the "Select File" button.<br>
              *The file must be uploaded in advance on the <a [href]="uploaderLink">Upload File Screen</a><br>
              *You can set an image for each language. If there is no image for the language, the English image will be displayed, and if no English image is registered, the Japanese image will be displayed.<br>
              *The recommended image size (aspect ratio) is as follows:<br>
              &nbsp;&nbsp;Logo image: 1:4.5 (example) height approximately 150px, width 700px
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> FAQ</div>
            <div class="manual-explain">
              Set FAQ.<br>
              Click the edit button to open the <a [href]="faqDialogLink">FAQ dialog</a> and set it up.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> Privacy Policy</div>
            <div class="manual-explain">
              Set a privacy policy.<br>
              Click the edit button to open the <a [href]="policyDialogLink">Policy dialog</a> and set it up.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> Copyright</div>
            <div class="manual-explain">
              Set the copyright.<br>
              Click the edit button to open the <a [href]="copyrightDialogLink">Copyright dialog</a> and set it up.<br>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- アプリ表示 -->
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Details(App Display)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/en_facility-dialog-disp.png" width="100%"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> Theme Color</div>
            <div class="manual-explain">
              Sets the theme color for the user app.<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> Do not display 'Menu' on the menu icon</div>
            <div class="manual-explain">
              If you check this, the image of the menu icon (button) will change from "icon + menu" to "icon" only.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> About using the "Language"</div>
            <div class="manual-explain">
              Set how to use the "Language" option.<br>
              "Globe": Changes the icon of the language switch button in the user app to a globe.<br>
              "Lang": Changes the icon of the language switch button in the user app to "Lang".<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>    
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> About using the "guide"</div>
            <div class="manual-explain">
              Set how to use the "Guide".<br>
              "Do not use": Hides the "Guide" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "Guide" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "Guide" only in the user app (PC size version).<br>
              "Use on smartphone"... The "Guide" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> About using the "Enter number"</div>
            <div class="manual-explain">
              Set how to use the "Enter number".<br>
              "Do not use": Hides the "Enter number" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "Enter number" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "Enter number" only in the user app (PC size version).<br>
              "Use on smartphone"... The "Enter number" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/F.png"> Change the menu 'Enter number' to another name</div>
            <div class="manual-explain">
              If you check this box, you can change the "Enter number" to an alias.<br>
              Open the <a [href]="nameDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
              <span class="manual-explain-notes">*Required if you check "Change the menu 'Enter number' to another name"</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/G.png"> Explanatory text</div>
            <div class="manual-explain">
              Set this if you want to change the "Enter the number of the exhibit you wish to see a description of." message that appears on the "Enter Number" page.<br>
              Open the <a [href]="nameDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/H.png"> About using the "questionnaire"</div>
            <div class="manual-explain">
              Set how to use the "questionnaire".<br>
              "Do not use": Hides the "questionnaire" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "questionnaire" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "questionnaire" only in the user app (PC size version).<br>
              "Use on smartphone"... The "questionnaire" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/I.png"> Display Thank You Page After Survey</div>
            <div class="manual-explain">
              If you check this box, you can display a thank you page after completing the survey.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/J.png"> Change "Thank you for responding to the survey"</div>
            <div class="manual-explain">
              By checking this box, you can change the "Thank you for responding to the survey" message that appears on the thank you page.<br>
              Open the <a [href]="nameDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
              <span class="manual-explain-notes">*Required if you check "Thank you for responding to the survey"</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/K.png"> About using the "Ranking"</div>
            <div class="manual-explain">
              Set how to use the "Ranking".<br>
              "Do not use": Hides the "Ranking" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "Ranking" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "Ranking" only in the user app (PC size version).<br>
              "Use on smartphone"... The "Ranking" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
             <div class="manual-explain-title"><img src="assets/img/manual/L.png"> About using the "shelter"</div>
            <div class="manual-explain">
              Set how to use the "shelter".<br>
              "Do not use": Hides the "shelter" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "shelter" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "shelter" only in the user app (PC size version).<br>
              "Use on smartphone"... The "shelter" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/M.png"> About using the "purchase"</div>
            <div class="manual-explain">
              Set how to use the "purchase".<br>
              "Do not use": Hides the "purchase" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "purchase" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "purchase" only in the user app (PC size version).<br>
              "Use on smartphone"... The "purchase" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/N.png"> Change the menu 'purchase' to another name</div>
            <div class="manual-explain">
              Set this if you want to change "purchase" to another name.<br>
              Open the <a [href]="nameDialogLink">Edit Dialog</a> from the edit button to configure it.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/O.png"> About using the "Overall Map"</div>
            <div class="manual-explain">
              Set how to use the "Overall Map".<br>
              "Do not use": Hides the "Overall Map" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "Overall Map" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "Overall Map" only in the user app (PC size version).<br>
              "Use on smartphone"... The "Overall Map" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/P.png"> What happens when you tap "View current position"</div>
            <div class="manual-explain">
              Set the behavior when you tap "View current position" on the "Overall map".<br>
              "Audio autoplay OFF": Content information will not be displayed automatically and audio will not be played.<br>
              "Auto-play audio ON(within 10m range of your current location)" - If there is content within 10m range of your current location, the nearest content information will be automatically displayed and audio will be played.<br>
              "Auto-play audio ON(within 20m range of your current location)" - If there is content within 20m range of your current location, the nearest content information will be automatically displayed and audio will be played.<br>
              "Auto-play audio ON(within 50m range of your current location)" - If there is content within 50m range of your current location, the nearest content information will be automatically displayed and audio will be played.<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/Q.png"> About using the "entry form"</div>
            <div class="manual-explain">
              Set how to use the "entry form".<br>
              "Do not use": Hides the "entry form" menu in the user app, making it unavailable.<br>
              "Use on PC and smartphone": Displays the "entry form" menu in the user app so that it can be used.<br>
              "Use on PC"... Displays and enables the use of the menu "entry form" only in the user app (PC size version).<br>
              "Use on smartphone"... The "entry form" menu will be displayed and usable only in the user app (smartphone-sized version).<br>
              <span class="manual-explain-notes">*Required field</span>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/R.png"> Floor Display Group List</div>
            <div class="manual-explain">
              Set the floor and display group.<br>
              Select a floor/display group from the Floor/Display Group List Add button.<br>
              *Floor and display groups must be registered in advance on the <a [href]="floorDialogLink">"Floor and Display Group Information Screen."</a><br>
              The floor and display group list can be rearranged by dragging and dropping.
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/S.png"> Do not display hierarchical navigation (breadcrumb list) at the top of the guide, 'Floor/Display Group'</div>
            <div class="manual-explain">
              If checked, the upper level navigation (breadcrumb list) on the guide page and floor/display group page will not be displayed.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/T.png"> Display 'Like' Button on Exhibit Page</div>
            <div class="manual-explain">
              If checked, a "Like" button will be displayed in the overview on the exhibit page.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/U.png"> Do Not Display 'Guide' and 'Number Input' Buttons on Exhibit Page</div>
            <div class="manual-explain">
              If checked, the "Guide" and "Enter Number" buttons on the exhibit page will not be displayed.<br>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

  </div>

  <!-- アプリ運用 -->
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Details(App Operation)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img"><img src="assets/img/manual/en_facility-dialog-ope.png" width="100%"></div>
        <div class="manual-grid">
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/A.png"> Meta Keyword</div>
            <div class="manual-explain">
              Set meta keywords.<br>
              This is reflected in the header meta tag: keywords.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/B.png"> Meta Description</div>
            <div class="manual-explain">
              Set the meta description.<br>
              This is reflected in the header meta tag: description.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/C.png"> Google Analytics Tracking Code</div>
            <div class="manual-explain">
              Set up the Google Analytics tracking code(G-XXXXXX).<br>
              *When using this service, please register with Google Analytics and let us know the tag information, and we will install it on your website.
            </div>
          </div>
          <div class="manual-item">
            <div class="manual-explain-title"><img src="assets/img/manual/D.png"> QR(URL) generation</div>
            <div class="manual-explain">
              Set the site URL for generating the QR code.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/E.png"> Staging Site URL</div>
            <div class="manual-explain">
              Set the staging site URL.<br>
            </div>
            <div class="manual-explain-title"><img src="assets/img/manual/F.png"> SPLATS Key</div>
            <div class="manual-explain">
              Set up the SPLATS key box.<br>
              When you select an environment (shared environment or production environment), a list of key boxes owned by that environment will be displayed under Name.<br>
              *The SPLATS key box must have the access token for the shared environment or production environment registered in advance on the <a [href]="splatsLink">"SPLATS Information Screen."</a><br>
              The SPLATS key box list can be reordered by drag and drop.
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>